import React from 'react'

let PanelRightColumn = ({ children }) => (
  <div className="panel-body-right">
    { children }
  </div>
)

export default PanelRightColumn
